import UploaderComponent from './UploaderComponent';

const AliossLoader = {
    install: function(Vue) {
        //注册全局组件
        Vue.component('alioss-uploader',UploaderComponent)
    }
}

export default AliossLoader